import { FormContextType, RegistryFieldsType, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';

import { AnyOfField } from './AnyOfField';

export function generateFields<
	T = unknown,
	S extends StrictRJSFSchema = RJSFSchema,
	F extends FormContextType = unknown
>(): RegistryFieldsType<T, S, F> {
	return {
		AnyOfField,
	};
}

export default generateFields();
